export default "__VITE_ASSET__B6enZbKq__"